import * as React from 'react';
import styled, { keyframes } from 'styled-components';

const smallAnimation = keyframes`
 0%,
	100% {
			background: var(--color-indicator-start-end);
		width: 5px;
		height: 5px;
		margin: 2.5px;
	}
	40%,
	60% {
		background: var(--color-indicator-mid);
		width: 0px;
		height: 0px;
		margin: 5px;
	}
`;

const largeAnimation = keyframes`
 0%,
	100% {
		background: var(--color-indicator-start-end);
		width: 25px;
		height: 25px;
		margin: 5px;
	}
	40%,
	60% {
		background: var(--color-indicator-mid);
		width: 15px;
		height: 15px;
		margin: 10px;
	}
`;

const DotContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const DotLarge = styled.div`
  margin: 5px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  animation-name: ${largeAnimation};
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  &:nth-child(2) {
    animation-delay: 0.3s;
  }
  &:nth-child(3) {
    animation-delay: 0.6s;
  }
`;

const DotSmall = styled.div`
  width: 5px;
  height: 5px;
  margin: 2.5px;
  animation-name: ${smallAnimation};
  animation-duration: 1.2s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  &:nth-child(2) {
    animation-delay: 0.3s;
  }
  &:nth-child(3) {
    animation-delay: 0.6s;
  }
`;

interface IProps {
  small?: boolean;
}

export const DotLoading = ({ small = false }: IProps): React.ReactElement => {
  return (
    <DotContainer>
      {small ? <DotSmall /> : <DotLarge />}
      {small ? <DotSmall /> : <DotLarge />}
      {small ? <DotSmall /> : <DotLarge />}
    </DotContainer>
  );
};
